import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-tryout-messages-in-use',
  templateUrl: './tryout-messages-in-use.component.html',
  styleUrls: ['./tryout-messages-in-use.component.css']
})
export class TryoutMessagesInUseComponent implements OnInit {

  @Input() NoOfMessagesInUse: string;
  @Output() filterProgramsEvent = new EventEmitter();

  program_status = '';

  constructor() { }

  ngOnInit() {
  }

  filterProgramListing(value) {
    this.program_status = value;
    this.filterProgramsEvent.emit(this.program_status);
  }
}



// WEBPACK FOOTER //
// ./src/app/tryout/components/tryout-messages-in-use/tryout-messages-in-use.component.ts